/* @jsx h */
import { defineComponent, h, onMounted } from "vue";
import { RouterView } from "vue-router";
import { PageComponent, useLocalization } from "@lemmonhq/uikit";
import { setTitle } from "@lemmonhq/orders";
export * from "./MyDay/index";
export * from "./Procedures/index";
export * from "./Prep/index";
export * from "./Tasks/index";
export * from "./Team/index";
export * from "./Rota/index";

// Work Day: MyDay, procedures, prep lists and tasks for the team.
// See docs/plans/workday/readme.md.
export const WorkDayPage = defineComponent({
  name: "WorkDayPage",
  setup() {
    const { t } = useLocalization();
    onMounted(() => setTitle(t("workday.nav.page_title")));

    return () => (
      <PageComponent
        title={t("workday.nav.page_title")}
        titleIcon="calendar_today"
        subpages={[
          { name: t("workday.nav.my_day"), icon: "today", href: "/app/workday/myday" },
          { name: t("workday.nav.procedures"), icon: "fact_check", href: "/app/workday/procedures" },
          { name: t("workday.nav.prep"), icon: "skillet", href: "/app/workday/prep" },
          { name: t("workday.nav.tasks"), icon: "task_alt", href: "/app/workday/tasks" },
          { name: t("workday.nav.rota"), icon: "calendar_view_week", href: "/app/workday/rota" },
          { name: t("workday.nav.team"), icon: "groups", href: "/app/workday/team" },
        ]}
      >
        <RouterView />
      </PageComponent>
    );
  },
});
